import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import "../../assets/css/icon.css";

const ModalHelper = ({ modalObjectInfo, onClose, fullWidth }) => {
  return (
    <Grid
      container
      item
      xs={11}
      md={fullWidth ? 8 : 5}
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#fff",
        maxHeight: "90%",
        borderRadius: "16px",
        zIndex: 1300,
        overflow: "auto",
        paddingRight: "2px",
      }}
      className="modal-helper-scroll"
    >
      {/* ── Header ── */}
      <Grid
        item
        xs={12}
        style={{
          height: "60px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #c6c6c6",
        }}
      >
        <Grid item xs={0.5} style={{ marginLeft: "15px" }}>
          <div className="icon-modal-info" />
        </Grid>
        <Grid item xs={11} sx={{ ml: { xs: 3, sm: 1 } }}>
          <Typography
            className="color-blue-dark"
            style={{ fontSize: "18px", marginTop: "3px", fontWeight: 600 }}
          >
            {modalObjectInfo.infoTitle}
          </Typography>
        </Grid>
        <Grid
          item
          xs={0.5}
          style={{
            marginRight: "15px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <div onClick={onClose} className="icon-modal-close" />
        </Grid>
      </Grid>

      {/* ── Body ── */}
      <Grid item xs={12} sx={{ display: "flex", flexDirection: "column" }}>
        <Typography
          className="color-blue-dark"
          sx={{
            padding: "10px 30px 0px 30px",
            marginTop: "20px",
            fontSize: { xs: "14px", md: "16px" },
          }}
        >
          {modalObjectInfo.description}
        </Typography>
        {modalObjectInfo.descriptionBis && (
          <Typography
            className="color-blue-dark"
            sx={{
              padding: "10px 15px 0px 15px",
              fontSize: { xs: "14px", md: "16px" },
            }}
          >
            {modalObjectInfo.descriptionBis}
          </Typography>
        )}
      </Grid>

      {/* ── Footer ── */}
      <Grid container item xs={12} style={{ marginTop: "20px" }}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "20px",
          }}
        >
          <Button
            className="button-bg-purple"
            onClick={onClose}
            sx={{ height: "40px", width: { xs: "120px", md: "140px" } }}
          >
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "14px", sm: "16px" },
                fontWeight: 500,
              }}
            >
              Chiudi
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModalHelper;
